<template>
  <div class="info-container" :class="{open: visible}">
    <div class="tag-container">
    <Tag v-for="f in filterArray" :key="f.name" :name="f.name" :value="f.value" :label="f.label" removable="true" @remove="onRemoveTag"></Tag>
    <FlatButton
      white
      :label="labels('clearAll')"
      inline-left
      v-if="filterArray && filterArray.length > 0"
      @click="onClearAll" class="clear-btn"
    ></FlatButton>
    <FlatButton
      blue
      :label="labels('changeFilters')"
      inline-left
      class="hide-on-desktop"
      @click="onShowFilters"
    ></FlatButton>
    </div>
    <div class="job-count" v-if="jobCount > 0">{{jobCount}} {{jobCount === 1 ? labels("singularJobs") : labels("pluralJobs")}}</div>
  </div>
</template>

<script>
import { FlatButton } from "clariant-vue3-forms";
import Tag from "./Tag.vue";
import { getLabel } from "../services/labels.js";

export default {
  name: "Info",
  props: ["filters", "visible", "job-count"],
  components: {
    Tag,
    FlatButton
  },
  data() {
    return {
      filterArray: []
    };
  },
  mounted() {
    this.updateFilterArray(this.filters);
  },
  methods: {
    labels(name) {
      return getLabel(name);
    },
    updateFilterArray(val) {
      this.filterArray = [];
      if (!val) return;
      for (let p in val) {
        if (val.hasOwnProperty(p) && val[p] && val[p].label) {
          //the label of the filter becomes the tag's value
          //the label of tag is the translated name of the filter
          let flt = {
            label: this.labels(p),
            value: val[p].label,
            name: p
          };
          this.filterArray.push(flt);
        }
      }
    },
    onClearAll() {
      this.$emit("clear");
    },
    onRemoveTag(tagName) {
      this.$emit("remove-filter", tagName);
    },
    onShowFilters () {
      this.$emit("show-filters");
    }
  },
  watch: {
    filters(val) {
      this.updateFilterArray(val);
    }
  }
};
</script>

<style scoped>
.info-container {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
}

.tag-container {
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.job-count {
  white-space: nowrap;
  min-height: 40px;
  font-weight: 700;
}

.hide-on-desktop {
  display: none;
}

.clear-btn {
  height: 41px;
  margin-right:10px !important;
}

@media all and (max-width: 800px) {
  .info-container {
    display: none;
  }
  .info-container.open {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .hide-on-desktop {
    display: block;
    height: 41px;
  }
}
</style>